const it = {
  navbar: {
    solutions: "Soluzioni",
    personal_area: "Area personale",
    training: "Servizi",
    consulenza: "Consulenza",
    open_lab: "Open Source",
    code: "Chi sono",
    contact: "Contatti",
    login: "Login",
    logout: "Logout",
    register: "Registrati",
    geoutilities: "Geo Utilities",
    ves: "V.E.S.",
    geodatabase:"Geodata",
    work:"Lavori"
  },

  footer: {
    f1: "Dott. Geol. Grechi Umberto - Pianoro 40065 (BO)",
  },

  pages: {


    home: {
      t2:"Soluzioni Digitali & Geologia e Territorio",
      ta:"In Evidenza",
      tb:"Soluzioni Digitali",
      a1: "Database prove Geognostiche e Geofisiche",
      a2: "V.E.S. Virtual Earth Suite",
      a3:"V.E.S. Testa gratuitamente",
      a4:"Sistemi Digitali Geospaziali Integrati",
      a5:"Sviluppo dedicato",
      a6:"V.E.S.",
      a7:"Servizi di elaborazione",
      a8:"ORIGAMI – Crea, pubblica e condividi il tuo WebGIS",
      dsch:`Piattaforme digitali operative, software specialistico e servizi di elaborazione dati per professionisti e aziende del settore geologico e ambientale.
            Dalla raccolta dati in campo alle analisi complesse, trasformiamo le informazioni territoriali in strumenti concreti per decisioni rapide e affidabili.`,
      s1:`Sviluppo di piattaforme WebGIS operativi che implentano funzionalita di gestione calcolo e analisi.`,
      s2:`Sviluppo software e applicativi su richiesta.`,
      s3:`Suite per elaborazione ed archiviazione prove geognistiche e geoofisiche.`,
      s4:`Servizi di elaborazione prove geognostiche, geotecniche e geofisiche.`,
      dsch2:`Consulenza geologica specialistica a supporto di progettisti,
        imprese e privati nella valutazione e gestione del territorio e del sottosuolo`,
      dsch3: "Esecuzione ed elaborazione prove penetrometriche",
      dsch4: "Esecuzione ed elaborazione indagini siscmiche",
      dsch5: "Redazione relazioni geologiche",
      dsch6: "Redazione relazioni di modellazione sismica",
      dsch7: "Cartografia Digitale",
      dsch8: "Rilievi topografici",
      imgdescr: [
        "Prova penetrometrica",
        "Valutazione fenomeno liquefazione",
        ],
    },

    
    geoutpg: {
      imgdescr: [
      "Elaborazione prove penetrometriche con CPT Office - Grafici",
      "Elaborazione prove penetrometriche con CPT Office - SBT",
      "Visualizzazione prove penetrometriche Archiviate su Database",
      "Editing sezioni stratigrafiche tra prove penetrometriche",
      "Sezione stratigrafica da prove penetrometriche",
      "Archiviazione e visualizzazione prove sisiche"
        ],
      t1: "Geo Utilities",
      t2: "Plugin QGis per:",
      t3: "Galleria",
      t4: "Ottieni Plugin Free",
      dsc1: "Elaborazione e archiviazione prove pentrometriche statiche CPT, CPTE e CPTU;",
      dsc2: "Verifica dell'indice di potenziale liquefazione;",
      dsc3: "Valutazione cedimenti post sismici;",
      dsc4: "Elaborazione e archiviazione prove dilatometriche DMT e SDMT;",
      dsc5: "Realizzazione sezioni di sondaggio;",
      dsc6: "Realizzazione sezioni stratigrafiche tra prove penetrometriche e/o sondaggi;",
      dsc7: "Archiviazione prove sismiche tipo HVSR, MASW e DH;",
      dsc8: "Visualizzazione valori e grafici dei dati archiviati.",


    },

    vests: {
      imgdescr2: [
        "Mobile App - acquisisci i dati in campo",
        "V.E.S. - Carica ed elabora i tuoi dati",
        "V.E.S. DB - Visualizza, gestisci modifica e condividi i dati",
        "V.E.S. DB - Confronta velocemente i dati archiviati",
        ],
      t5: "V.E.S.",
      t6: "Virtual Earth Suite",
      t7:"Dati gestiti e archiviati:",
      t8:"Prove penetrometriche",
      t9:"Prove dilatometriche",
      t10:"Sondaggi",
      t11:"Sezioni stratigrafiche",
      t12:"Prove HVSR, MASW e Down Hole",
      t13:"Calcola:",
      t14:"Verifica a liquefazione",
      t15:"Cedimenti post sismici free field",
      t18:"Richiedi informazioni",
      dsc10: `V.E.S. (Virtual Earth Suite) è una piattaforma software integrata per professionisti del settore geologico e geotecnico.`,
      dsc11: `La suite supporta l’intero flusso di lavoro: dalla raccolta dati in campo fino all’elaborazione e modellazione in ufficio, centralizzando tutte le informazioni in un unico ambiente digitale.`,
      dsc12: `Durante le fasi di acquisizione, V.E.S. consente la geolocalizzazione e l’archiviazione automatica dei punti di prova, garantendo tracciabilità e organizzazione dei dati.`,
      dsc13: `In fase di analisi, la piattaforma esegue elaborazioni avanzate e genera risultati ingegneristici pronti all’uso.`


    },

    digsev:{
      ds1: "Sistemi Digitali Geospaziali Integrati",
      ds2:`Realizziamo piattaforme WebGIS, soluzioni SaaS e applicativi personalizzati che consentono di acquisire,
          gestire, analizzare e condividere dati territoriali in modo strutturato ed efficiente. Dalla raccolta dati in campo
          alla modellazione e visualizzazione avanzata, integriamo cartografia digitale, database spaziali e strumenti di analisi
          per supportare professionisti, studi tecnici e aziende nella gestione del territorio e del sottosuolo.`,
      ds3:"Cosa sviluppiamo:",
      ds4:"WebGIS operativi per la gestione e visualizzazione di dati geospaziali",
      ds5:"Piattaforme SaaS per archiviazione e condivisione dati tecnici",
      ds6:"Database geologici e geotecnici strutturati",
      ds7:"Sistemi per gestione prove geognostiche e geofisiche",
      ds8:"Strumenti digitali per workflow topografici",
      ds9:"Dashboard ambientali e sistemi di monitoraggio",
      ds10:"Integrazione API e servizi cartografici (WMS, WFS)",
    },

    elab_sev:{
      els1: "Servizio Elaborazioni Prove e Modellazione",
      els2:`Offro servizi specialistici di elaborazione, interpretazione e modellazione dei dati provenienti da
       indagini geognostiche e geofisiche, supportando studi professionali, società di ingegneria,
       imprese e pubbliche amministrazioni in tutte le fasi di analisi e gestione delle informazioni.`,
      els3:"Elaborazione prove geognostiche",
      els4:"Sondaggi",
      els5:"Prove penetrometriche (CPT, CPTE, CPTU, SCPTU)",
      els6:"Prove dilatometriche (DMT, SDMT)",

      els7:"Elaborazione prove geofisiche",
      els8:"Indagini HVSR e MASW",
      els9:"Tomografie elettriche (ERT)",
      els10:"Down Hole e sismica a rifrazione",

      els11:"Modellazione",
      els12:"Analisi di risposta sismica locale",
      els13:"Ricostruzioni stratigrafiche",
      els14:"Supporto alla progettazione preliminare ed esecutiva",

      els15:"Analisi geospaziali e servizi GIS",
      els16:"Produzioni di cartografia tematica",
      els17:"Analisi a supporto della pianificazione territoriale",
      els18:"Analisi geomorfologiche a supporto di studi geologici e idrologici",
    },

    login: {
      tl: "Login",
      l1:"Utente",
      l2:"Password",
      l3:"Accedi",
      l4:"Password dimenticata?",
      l5:"Non hai ancora un account?",
      l6:"Acquista un piano",
      l7:"Reset Password",
      l8:"contattaci",
    },

    register: {
      rl: "Richiedi V.E.S.",
      r5:"Invia richiesta",
      r2:"Password ritrovata?",
      r3:"Ritorna al login",
      r6:"Accetto i termini e la privacy policy",
      r7:"Vedi dettagli",
    },

    toast:{
    ts1:"Invio della richiesta in corso...",
    ts2:"La sua richiesta è stata presa in carico.",
    ts3:"Si è verificato un errore durante l'invio della richiesta. Riprova più tardi.",
    ts4:'User or password non corretti!',

    },

    layer: {
      Tgla1: "GeoData",
      Tpla1: "Layer",
      Pla1: "Prove Geognostiche",
      Tla1: "CPT",
      Tla2: "CPTU",
      Tla3: "CPTE",
      Tla4: "DMT",
      Tla5: "SDMT",
      Tla6: "DIN",
      Pla2: "Prove Geofisiche",
      Tla7: "HVSR",
      Tla8: "MASW",
      Tla9: "REMI",
      Tla10: "DH",
      Tla11: "CH",
      Tla12: "ARRAY SISMICO",
      Pla3: "Sondaggi - Pozzi",
      Tla13: "POZZO",
      Tla14: "SONDAGGIO",
      Tla15: "SONDAGGIO IDROCARBURI",
      Tla16: "SONDAGGIO OFFSHORE",
      ld1: "Manuali & Legende",
      ld2: "Attribuzioni & Licenze",
    },

    whoim:{
        w1:"Umberto Grechi",
        w2:"Geologo • GIS Specialist • Software Developer",
        w3:"Chi sono",
        w4: `Ho iniziato il mio percorso professionale come Geometra
                                occupandomi di rilievi topografici, sviluppando una forte
                                comprensione pratica del territorio e dei dati tecnici.`,
        w5: `Successivamente ho conseguito laurea triennale e magistrale
                                in Geologia, specializzandomi in cartografia e sistemi GIS.
                                Lavorando con dati geospaziali ho iniziato a sviluppare strumenti
                                software per automatizzare analisi e processi.`,
        w6:`Oggi progetto e realizzo applicativi digitali pensati per
                                professionisti tecnici, integrando competenze scientifiche,
                                GIS e sviluppo software.`,
        w7:"Competenze",
        w8:"GIS & Geospatial",
        w9:"QGIS & Cartografia digitale",
        w10:"WebGIS",
        w11:"Spatial data management",
        w12:"Analisi geospaziale",
        w13:"Sviluppo Software",
        w14:"React",
        w15:"JavaScript",
        w16:"AJAX",
        w17:"Web Applications",
        w18:"API Integration",
        w19:"Python",
        w20:"Django",
        w21:"PostgeSQL",
        w22:"Geologia & Topografia",
        w23:"Redazione relazioni geologiche",
        w24:"Modellazione sismica",
        w25:"Esecuzione ed elaborazione provee geognostiche e geofisiche",
        w26:"Rilievi topografici",
        w27:"Il progetto sofHare",
        w28:`sofHare nasce dall'esigenza reale dei professionisti tecnici
                                di avere strumenti digitali flessibili, semplici e adattabili
                                ai propri flussi di lavoro.`,
        w29:"Archiviazione strutturata dei dati geospaziali",
        w30:"Strumenti personalizzati per workflow tecnici",
        w31:"Semplicità di utilizzo e integrazione",
        w32:"Portfolio lavori",
    },

    portfolio:{
        ptf1:"V.E.S. piattaforma integrata per elaborazione, archiviazione e gestione prove geognostiche.",
        ptf2:"Gestione discariche, dal moonitoraggio allo stato avanzamento lavori.",
        ptf3:"Database prove geognostiche - archivi regionali",

        imgdescrptf1: [
        "Database Prove",
        "Database Prove - visualizzazione dati",
        "Strumenti di elaborazione prove penetrometriche",
        "Strumenti di elaborazione sondaggi",
        "App Android per acquisizione dati in sito e gestione dati da desktop in tempo reale",
        ],

        imgdescrptf2: [
        "WebGIS",
        "Strumenti di editing",
        "Strumenti di analisi ed export",
        ],

        imgdescrptf3: [
        "WebGIS - prove geognostiche regionali",
        "Consultazione dati",
        ],


    },

  }
};

export default it;
